import Vue from 'vue'
import VueI18n from 'vue-i18n'
import moment from 'moment'
// default lang
import zhCN from './lang/zh_CN'
import mergeMessage from './messages'
// ant lang
import ANTzhCN from 'ant-design-vue/es/locale/zh_CN'
import ANTenUS from 'ant-design-vue/es/locale/en_US'
// import ANTkoKR from 'ant-design-vue/es/locale/ko_KR'

import './tools.js'
// console.log(moment)// 如果你不知道你自己当前所在地的时区，请使用此代码查看.

Vue.use(VueI18n)

export const defaultLang = 'zh_CN'

sessionStorage.setItem('refresh-windows-time', moment().format('MMMM Do YYYY, h:mm:ss a'))

const messages = {
  'zh_CN': Object.assign(zhCN, concatLanguage(mergeMessage, defaultLang))
}

const i18n = new VueI18n({
  silentTranslationWarn: true,
  locale: defaultLang,
  fallbackLocale: defaultLang,
  messages
})

const loadedLanguages = ['zh_CN']

function concatLanguage (data, lang) {
  let langCodes = {
    'zh_CN': 'cn',
    'en_US': 'en'
  }
  let _data = {}
  for (let i of Object.keys(data)) {
    _data[i] = data[i][langCodes[lang]]
  }
  return _data
}

function setI18nLanguage (lang) {
  i18n.locale = lang
  document.querySelector('html').setAttribute('lang', lang.substr(0, 2))
  return lang
}

export function loadLanguageAsync (lang = defaultLang) {
  return new Promise(resolve => {
    // 缓存语言设置
    if (i18n.locale !== lang) {
      if (!loadedLanguages.includes(lang)) {
        return import (/* webpackChunkName: "lang-[request]" */ `./lang/${lang}`).then(msg => {
          const locale = Object.assign(msg.default, concatLanguage(mergeMessage, lang))
          i18n.setLocaleMessage(lang, locale)
          loadedLanguages.push(lang)
          moment.updateLocale(locale.momentName, locale.momentLocale)
          // console.log('import:locale', locale, locale.momentName)
          Vue.prototype.$moment = moment
          resolve(setI18nLanguage(lang))
        })
      }
      return resolve(setI18nLanguage(lang))
    }
    return resolve(lang)
  })
}

export function i18nRender (key) {
  return i18n.t(`${key}`)
}

export function getAntLangPack (lang) {
  return {
    'zh_CN': ANTzhCN,
    'en_US': ANTenUS
  }[lang]
}

Vue.prototype.$isDev = process.env.NODE_ENV === 'development'

export default i18n
